const tileData = [
  {
    img: '/static/images/unsplash/5.jpg',
    title: 'Breakfast',
    author: 'jill111',
    cols: 2,
    featured: true,
  },
  {
    img: '/static/images/unsplash/6.jpg',
    title: 'Tasty burger',
    author: 'director90',
  },
  {
    img: '/static/images/unsplash/7.jpg',
    title: 'Camera',
    author: 'Danson67',
  },
  {
    img: '/static/images/unsplash/8.jpg',
    title: 'Morning',
    author: 'fancycrave1',
    featured: true,
  },
  {
    img: '/static/images/unsplash/9.jpg',
    title: 'Hats',
    author: 'Hans',
  },
  {
    img: '/static/images/unsplash/10.jpg',
    title: 'Honey',
    author: 'fancycravel',
  },
  {
    img: '/static/images/unsplash/11.jpg',
    title: 'Vegetables',
    author: 'jill111',
    cols: 2,
  },
  {
    img: '/static/images/unsplash/12.jpg',
    title: 'Water plant',
    author: 'BkrmadtyaKarki',
  },
  {
    img: '/static/images/unsplash/13.jpg',
    title: 'Mushrooms',
    author: 'PublicDomainPictures',
  },
  {
    img: '/static/images/unsplash/14.jpg',
    title: 'Olive oil',
    author: 'congerdesign',
  },
  {
    img: '/static/images/unsplash/15.jpg',
    title: 'Sea star',
    cols: 2,
    author: '821292',
  },
  {
    img: '/static/images/unsplash/16.jpg',
    title: 'Bike',
    author: 'danfador',
  },
];

export default tileData;
